import React, { useEffect, useState } from 'react';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import PageTitle from '../../components/pageTitle/PageTitle';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';
import styles from './inventory.module.css';
import axiosRequest from '../../services/axios/axiosRequest';
import InventoryTable from '../../components/inventoryTable/InventoryTable';
import Loading from '../../components/loading/Loading';
import { stringToTitle } from '../../utils';


const columns = [
  { field: 'row', headerName: '', flex: 0.5, disableColumnMenu: true, renderCell: (params) => params.api.getRowIndexRelativeToVisibleRows(params.id) + 1 },
  {
    field: 'image', headerName: 'نمایه', flex: 1, renderCell: (params) => {
      return <>{params.value && <img className={styles.image} src={params.value} alt={params.row.name} loading='lazy' />}</>
    }
  },
  { field: 'name', headerName: 'عنوان', flex: 5, },
  { field: 'volume', headerName: 'حجم', flex: 2, },
  { field: 'cat', headerName: 'Cat', flex: 2, },
  { field: 'cas', headerName: 'Cas', flex: 2, },
  { field: 'brand', headerName: 'کمپانی', flex: 3, },
];

export default function Inventory() {

  const navigateTo = useNavigate();
  const { slug } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [inventory, setInventory] = useState({});

  useEffect(() => {
    const inventoryController = new AbortController();
    axiosRequest.get(`/brands/${slug}`, { signal: AbortSignal.timeout(10000) })
      .then(res => setInventory(res.data))
      .catch(err => { if (err?.response?.data?.detail === "Not found.") navigateTo('/notFound') })
      .finally(() => setIsLoading(false));
    return () => inventoryController.abort();
  }, []);

  return (
    <>
      <Helmet>
        {isLoading ?
          <>
            <title>موجودی - نوآوران پژوه</title>
            <meta name="description" content="لیست موجودی شرکت نوآوران پژوه" />
          </>
          :
          <>
            <title>{`موجودی برند ${stringToTitle(slug.replaceAll('-', ' '))} - نوآوران پژوه`}</title>
            <meta name="description" content={`لیست موجودی کمپانی ${stringToTitle(slug.replaceAll('-', ' '))} شرکت نوآوران پژوه`} />
          </>
        }
      </Helmet>

      <Header />

      <main className='mainContainer container-lg'>
        {isLoading ? <Loading /> :
          <>
            <PageTitle title={`موجودی برند ${stringToTitle(slug.replaceAll('-', ' '))}`} url={inventory?.url} views={inventory?.views} />
            <div className={styles.table_container}>
              <InventoryTable rows={inventory?.results} columns={columns} isLoading={false} />
            </div>
          </>
        }
      </main>

      <Footer />
    </>
  );
}